<template>
 <v-dialog v-model="visible" persistent max-width="500px">
    <v-card>
    <v-card-text>
      <v-form ref="serviceCreationForm" v-model="isValid" v-show="visible">
        <v-text-field
          v-model="newService.title"
          label="Title"
          :rules="titleRules"
          required
        ></v-text-field>
        <v-text-field
          v-model="newService.code"
          label="Code"
          :rules="codeRules"
          required
        ></v-text-field>
        <v-select
          :items="availableServiceGroups"
          v-model="newService.groupId"
          placeholder="Select group"
          item-text="title"
          item-value="id"
          clearable>
          <template slot="item" slot-scope="data">
            <v-list-tile-content>
              <v-list-tile-title>
                <span v-bind:style="{ color: data.item.colorScheme}">{{data.item.title}}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </template>
          <template slot="selection" slot-scope="data">
            <v-list-tile-content>
              <v-list-tile-title>
                <span v-bind:style="{ color: data.item.colorScheme}">{{data.item.title}}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </template>
        </v-select>
        <v-text-field
          v-model="newService.price"
          label="Base price"
          :rules="priceRules"
          required
        ></v-text-field>
        <v-text-field
          v-model="newService.initialScopeOfWork"
          label="Initial scope of work"
          :rules="initialScopeOfWorkRules"
        ></v-text-field>
        <v-select
          :items="availableContractors"
          v-model="newService.contractorId"
          item-value="id"
          item-text="title"
          label="Service contractor"
          clearable
          persistent-hint
        ></v-select>
        <v-select
          :items="availableTypes"
          v-model="newService.type"
          label="Service type"
          clearable
          persistent-hint
        ></v-select>
        <v-alert
          :value="hasError"
          type="error"
          outline
        >
          {{ errorMessage }}
        </v-alert>
        <v-btn
          :disabled="!isValid"
          @click="handleOkClick"
        >
          Save
        </v-btn>
        <v-btn @click="handleCancelClick">Cancel</v-btn>
      </v-form>
    </v-card-text>
    </v-card>
 </v-dialog>
</template>

<script>
import _ from 'lodash'
import api from '../../api'
import {extractErrorToString} from '../../helpers/api'
import {validateStringLength} from '../../helpers/validation'

const emptyService = {
  id: null,
  code: null,
  title: null,
  price: null,
  initialScopeOfWork: null,
  contractorId: null,
  groupId: null,
  type: null,
}

export default {
  name: 'service-creation-form',
  filters: {},
  props: {
    visible: {
      type: Boolean
    },
    selectedServiceItem: {
      type: Object
    },
    availableContractors: {
      type: Array
    },
    availableServiceGroups: {
      type: Array
    }
  },
  data () {
    return {
      hasError: null,
      loading: false,
      isValid: false,
      errorMessage: null,
      newService: _.clone(emptyService),
      titleRules: [
        v => !!v || 'Enter service title',
        v => (v && v.length <= 1000) || 'The length of the name should be no more than 1000 characters'
      ],
      codeRules: [
        v => !!v || 'Enter service code',
        v => (v && v.length <= 255) || 'Service code must be no more than 255 characters'
      ],
      priceRules: [
        v => !!v || 'Enter service base price'
      ],
      initialScopeOfWorkRules: [
        _.partial(validateStringLength, _, 2000, 'The length of the initial scope of work should be no more than 2000 characters')
      ],
      availableTypes: ['GENETIC', 'IHC', 'CYTOLOGY']
    }
  },
  beforeCreate () {

  },
  watch: {
    visible: function(){
      if (this.visible && this.selectedServiceItem){
        this.newService = _.clone(this.selectedServiceItem)
      }
    }
  },
  mounted () {
  },
  methods: {
    async handleOkClick () {
      this.hasError = null
      this.errorMessage = null

      if (this.newService.id){
        try {
          let updatedItem = await api.updateService(this.newService)
          this.$emit('updated', updatedItem)
          this.resetNewService()
        } catch (e) {
          this.hasError = true
          this.errorMessage = extractErrorToString(e, 'Unable to update service')
        }

        return
      }

      try {
        await api.createService(this.newService)
        this.resetNewService()
        this.$emit('created')
      } catch (e) {
        this.hasError = true
        this.errorMessage = extractErrorToString(e, 'Unable to create service')
      }
    },
    handleCancelClick () {
      this.resetNewService()
    },
    resetNewService () {
      this.hasError = null
      this.errorMessage = null
      this.$refs.serviceCreationForm.reset()
      this.newService = _.clone(emptyService)

      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ServiceCreationForm.vue